import { ApiClient, normalizeApiUrl } from '@inspace-org/client';
import env from '../../env';
import { apiCredentials } from './credentials';
import { language } from '../../localization';

export const apiUrl = normalizeApiUrl(env.apiUrl);

export const api = new ApiClient({ baseUrl: apiUrl, prefix: '/api', credentials: apiCredentials, language });
